import script from "./HardwareControlBrief.vue?vue&type=script&setup=true&lang=js"
export * from "./HardwareControlBrief.vue?vue&type=script&setup=true&lang=js"

import "./HardwareControlBrief.vue?vue&type=style&index=0&id=5da030f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5da030f4"]])

export default __exports__